import React, { useState, useEffect } from "react";
import { Select } from "@irati/ui/src/FormItem";
import teamService from "@irati/identity/services/teams";
import authentication from "@irati/auth";
import Validation from "@irati/utils/validation";
import { injectIntl } from "@irati/utils/lang";
var CBTeamSelect = function (props) {
    var _a = useState(true), isLoading = _a[0], setIsloading = _a[1];
    var _b = useState([]), options = _b[0], setOptions = _b[1];
    useEffect(function () {
        teamService.list(authentication.userTenant().uuid).then(function (teams) {
            setOptions(teams.map(function (_a) {
                var uuid = _a.uuid, public_name = _a.public_name;
                return ({ value: uuid, label: public_name });
            }));
            setIsloading(false);
        });
    }, []);
    return (React.createElement(Select, { isMulti: true, isCreatable: true, isLoading: isLoading, options: options, value: props.value, onChange: props.onChange, label: props.formatMessage({ id: "admin.companyBenefits.teams.label" }), validation: Validation.string(props.formatMessage({ id: "admin.companyBenefits.teams.error" })) }));
};
export default injectIntl(CBTeamSelect);
